const initialState = {
  playback: 0, // -1 loading, 0 stopped, 1 playing, 2 paused, 3 error
  tracks: [],
  playlists: [],
  playlist: 0,
  track: 0,
  total: 0,
  mute: false,
  scrubbing: false,
  progress: 0,
  currentTime: 0,
  duration: 0,
  autoplay: false
}

const RadioReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_PLAYBACK':
      return Object.assign({}, {
        ...state,
        playback: action.value
      })
    case 'SET_AUTOPLAY':
      return Object.assign({}, {
        ...state,
        autoplay: action.value
      })
    case 'PLAY_PAUSE':
      return Object.assign({}, {
        ...state,
        playback: state.playback === 1 ? 2 : 1
      })
    case 'PLAY_TRACK':
      return Object.assign({}, {
        ...state,
        track: action.value
      })
    case 'PLAY_NEXT':
      return Object.assign({}, {
        ...state,
        track: state.track + 1 < state.total ? state.track + 1 : 0,
        playlist: state.track + 1 < state.total ? state.playlist : state.playlist + 1 < state.playlists.length ? state.playlist + 1 : 0
      })
    case 'MUTE':
      return Object.assign({}, {
        ...state,
        mute: !state.mute
      })
    case 'TOGGLE_SCRUBBING':
      return Object.assign({}, {
        ...state,
        scrubbing: !state.scrubbing
      })
    case 'SCRUBBING_ON':
      return Object.assign({}, {
        ...state,
        scrubbing: true
      })
    case 'SCRUBBING_OFF':
      return Object.assign({}, {
        ...state,
        scrubbing: false
      })
    case 'UPDATE_PLAYLISTS':
      return Object.assign({}, {
        ...state,
        playlists: action.value
      })
    case 'LOAD_TRACKS':
      return Object.assign({}, {
        ...state,
        tracks: action.value.tracks,
        track: 0,
        total: action.value.tracks ? action.value.tracks.length : 0,
        playlist: state.playlists.map(e => e.uid).indexOf(action.value.uid)
      })
    case 'UPDATE_CURRENTTIME':
      return Object.assign({}, {
        ...state,
        currentTime: action.value
      })
    case 'UPDATE_PROGRESS':
      return Object.assign({}, {
        ...state,
        progress: action.value
      })
    case 'UPDATE_DURATION':
      return Object.assign({}, {
        ...state,
        duration: action.value
      })
    default:
      return state
  }
}

export default RadioReducer
